//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TestPDFMake",

  data() {
    return {
      pdfMakeReady: false,
      statement: {
        // ข้อมูลบริษัท
        companyName: "DEJ-UDOM & ASSOCIATES",
        companyNameThai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
        companyType: "ATTORNEYS AT LAW",
        taxId: "0992000028227",
        address:
          "CHARN ISSARA TOWER 1, 2nd FLOOR,\n942/69 RAMA IV ROAD,\nKWAENG SURIYAWONG, KHET BANGRAK,\nBANGKOK 10500, THAILAND",
        phone: "Tel : 0-2233-0055, 0-2267-5152",
        email: "E-MAIL : account@dejudom.com",

        // ข้อมูลลูกค้า
        clientName: "ALPHATECH SEMICONDUCTOR",
        clientTaxId: "0 / -",
        clientAddress: "ddddddddddddddddd bangkok , 10150 Thailand",

        // ข้อมูลเอกสาร
        documentNo: "L25100004",
        date: "2025-10-17",
        attention: "- / null",
        periodCovered: "-",
        documentRef: ":-",

        // รายการบริการ
        serviceDescription:
          "TO OUR CHARGES for professional service rendered to ALPHATECH SEMICONDUCTOR in connection with",
        amount: 500.0,
        withholdingTaxPercent: 0.0,
        vatPercent: 7.0,

        // หมายเหตุ
        importantNote:
          "IMPORTANT: Payment must be paid in full, without deductions of foreign bank fees or taxes; we will solely be responsible for Thai tax.",
        disclaimer:
          "Cybersecurity & Wire Transfer Disclaimer\n\nDej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must independently be verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt.",
      },
    };
  },

  computed: {
    withholdingTax() {
      return (
        this.statement.amount * (this.statement.withholdingTaxPercent / 100)
      );
    },
    vat() {
      return this.statement.amount * (this.statement.vatPercent / 100);
    },
    grandTotal() {
      return this.statement.amount - this.withholdingTax + this.vat;
    },
  },

  mounted() {
    this.waitForPdfMake();
    this.$hideLoader();
  },

  methods: {
    waitForPdfMake() {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          this.pdfMakeReady = true;
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน");
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.pdfMakeReady) {
          console.error("❌ pdfMake โหลดไม่สำเร็จ");
          alert("ไม่สามารถโหลดระบบ PDF ได้");
        }
      }, 10000);
    },

    formatNumber(number) {
      return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    numberToText(num) {
      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ];
      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];
      const teens = [
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      const numToWords = (n) => {
        if (n === 0) return "Zero";
        if (n < 10) return ones[n];
        if (n < 20) return teens[n - 10];
        if (n < 100)
          return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        if (n < 1000)
          return (
            ones[Math.floor(n / 100)] +
            " Hundred" +
            (n % 100 ? " " + numToWords(n % 100) : "")
          );
        return n.toString();
      };

      const intPart = Math.floor(num);
      const decPart = Math.round((num - intPart) * 100);

      let result = numToWords(intPart);
      if (decPart > 0) {
        result += " Point " + numToWords(decPart);
      }
      return `(${result})`;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    generateDocDefinition() {
      return {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],

        content: [
          // Header - ชื่อบริษัท
          {
            text: this.statement.companyName,
            style: "companyName",
            alignment: "center",
          },
          {
            text: this.statement.companyType,
            style: "companyType",
            alignment: "center",
            margin: [0, 2, 0, 0],
          },
          {
            text: this.statement.companyNameThai,
            style: "companyNameThai",
            alignment: "center",
            margin: [0, 3, 0, 0],
          },
          {
            text: this.statement.address,
            style: "address",
            alignment: "center",
            margin: [0, 5, 0, 0],
          },
          {
            text: this.statement.phone,
            style: "contact",
            alignment: "center",
            margin: [0, 3, 0, 0],
          },
          {
            text: this.statement.email,
            style: "contact",
            alignment: "center",
            margin: [0, 2, 0, 0],
          },
          {
            text: `TAX ID. No. ${this.statement.taxId}/ "HEAD OFFICE"`,
            style: "contact",
            alignment: "center",
            margin: [0, 2, 0, 15],
          },

          // STATEMENT Title
          {
            columns: [
              { width: "*", text: "" },
              {
                width: "auto",
                stack: [
                  {
                    text: "STATEMENT",
                    style: "statementTitle",
                  },
                ],
              },
              {
                width: 100,
                stack: [
                  {
                    text: "ORIGINAL",
                    style: "originalMark",
                    alignment: "right",
                  },
                  {
                    text: `No. / เลขที่ : ${this.statement.documentNo}`,
                    style: "docNumber",
                    alignment: "right",
                    margin: [0, 2, 0, 0],
                  },
                ],
              },
            ],
            margin: [0, 0, 0, 15],
          },

          // ข้อมูลลูกค้าและวันที่
          {
            columns: [
              {
                width: "55%",
                stack: [
                  {
                    text: [
                      { text: "To/ถึง :     ", style: "label" },
                      { text: this.statement.clientName, style: "value" },
                    ],
                  },
                  {
                    text: `               ${this.statement.clientAddress}`,
                    style: "value",
                    margin: [0, 2, 0, 10],
                  },
                  {
                    text: [
                      { text: "TAX ID :    ", style: "label" },
                      { text: this.statement.clientTaxId, style: "value" },
                    ],
                  },
                ],
              },
              {
                width: "45%",
                stack: [
                  {
                    text: [
                      { text: "Date/วันที่ : ", style: "label" },
                      {
                        text: this.formatDate(this.statement.date),
                        style: "value",
                      },
                    ],
                    alignment: "left",
                  },
                  {
                    text: [
                      {
                        text: "Period Covered / รอบระยะเวลา :    ",
                        style: "label",
                      },
                      { text: this.statement.periodCovered, style: "value" },
                    ],
                    margin: [0, 2, 0, 0],
                  },
                  {
                    text: [
                      { text: "Attention :   ", style: "label" },
                      { text: this.statement.attention, style: "value" },
                    ],
                    margin: [0, 2, 0, 10],
                  },
                  {
                    text: [
                      { text: "Document Ref. ", style: "label" },
                      { text: this.statement.documentRef, style: "value" },
                    ],
                  },
                ],
              },
            ],
            margin: [0, 0, 0, 15],
          },

          // ตารางรายการ
          {
            table: {
              widths: ["*", 100],
              body: [
                [
                  { text: "Description / รายการ", style: "tableHeader" },
                  {
                    text: "Amount / จำนวนเงิน",
                    style: "tableHeader",
                    alignment: "right",
                  },
                ],
                [
                  {
                    stack: [
                      {
                        text: this.statement.serviceDescription,
                        style: "description",
                        margin: [5, 10, 5, 300],
                      },
                      {
                        text: this.statement.importantNote,
                        style: "important",
                        margin: [5, 0, 5, 10],
                      },
                    ],
                  },
                  {
                    text: this.formatNumber(this.statement.amount),
                    style: "amount",
                    alignment: "right",
                    margin: [5, 10, 5, 0],
                  },
                ],
                [
                  { text: "Sub Total / รวมเป็นเงิน", style: "subtotalLabel" },
                  {
                    text: this.formatNumber(this.statement.amount),
                    style: "subtotalAmount",
                    alignment: "right",
                  },
                ],
                [
                  {
                    text: `Less Withholding Tax / ภาษีเงินได้ หัก ณ ที่จ่าย (${this.formatNumber(
                      this.statement.withholdingTaxPercent
                    )} %)`,
                    style: "subtotalLabel",
                  },
                  {
                    text: this.formatNumber(this.withholdingTax),
                    style: "subtotalAmount",
                    alignment: "right",
                  },
                ],
                [
                  {
                    text: "Grand Total / ยอดรวม",
                    style: "grandTotalLabel",
                    bold: true,
                  },
                  {
                    text: this.formatNumber(this.grandTotal),
                    style: "grandTotalAmount",
                    alignment: "right",
                    bold: true,
                  },
                ],
                [
                  {
                    text: this.numberToText(this.grandTotal),
                    style: "amountText",
                    alignment: "center",
                    colSpan: 2,
                  },
                  {},
                ],
              ],
            },
            layout: {
              hLineWidth: function(i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 1
                  : 0.5;
              },
              vLineWidth: function() {
                return 1;
              },
            },
          },

          // หมายเหตุใต้ตาราง
          {
            text:
              "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
            style: "note",
            alignment: "center",
            margin: [0, 10, 0, 3],
          },
          {
            text:
              "โปรดส่งหนังสือรับรองภาษีหักภาษี ณ ที่จ่ายมาพร้อมกับเงินค่าบริการระงเงิน",
            style: "noteThai",
            alignment: "center",
            margin: [0, 0, 0, 15],
          },

          // Disclaimer
          {
            text: "Cybersecurity & Wire Transfer Disclaimer",
            style: "disclaimerTitle",
            color: "red",
            margin: [0, 0, 0, 5],
          },
          {
            text: this.statement.disclaimer,
            style: "disclaimerText",
            color: "red",
          },
        ],

        styles: {
          companyName: {
            fontSize: 16,
            bold: true,
          },
          companyType: {
            fontSize: 11,
            bold: true,
          },
          companyNameThai: {
            fontSize: 13,
            bold: true,
          },
          address: {
            fontSize: 9,
          },
          contact: {
            fontSize: 9,
          },
          statementTitle: {
            fontSize: 20,
            bold: true,
          },
          originalMark: {
            fontSize: 11,
            bold: true,
          },
          docNumber: {
            fontSize: 10,
          },
          label: {
            fontSize: 10,
            bold: false,
          },
          value: {
            fontSize: 10,
          },
          tableHeader: {
            fontSize: 11,
            bold: true,
            fillColor: "#ffffff",
          },
          description: {
            fontSize: 10,
          },
          important: {
            fontSize: 9,
            bold: true,
          },
          amount: {
            fontSize: 11,
          },
          subtotalLabel: {
            fontSize: 10,
            bold: true,
          },
          subtotalAmount: {
            fontSize: 10,
          },
          grandTotalLabel: {
            fontSize: 11,
            bold: true,
          },
          grandTotalAmount: {
            fontSize: 11,
            bold: true,
          },
          amountText: {
            fontSize: 9,
            italics: true,
          },
          note: {
            fontSize: 9,
          },
          noteThai: {
            fontSize: 9,
          },
          disclaimerTitle: {
            fontSize: 10,
            bold: true,
          },
          disclaimerText: {
            fontSize: 8,
          },
        },

        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
    },

    previewPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        pdfMake.createPdf(docDefinition).open();
        console.log("✅ เปิดตัวอย่าง PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    downloadPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        const fileName = `Statement_${this.statement.documentNo}_${this.statement.date}.pdf`;
        pdfMake.createPdf(docDefinition).download(fileName);
        console.log("✅ ดาวน์โหลด PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการดาวน์โหลด PDF: " + error.message);
      }
    },
  },
};
